let productSwiper;

function initProductSwiper() {
  const swiperEl = document.querySelector('.product-swiper');

  if (!swiperEl) return;

  // Wait until Swiper bundle has loaded (it's deferred for speed)
  if (typeof Swiper === 'undefined') return;

  // Avoid double initialization
  if (swiperEl.classList.contains('swiper-initialized')) {
    return;
  }

  productSwiper = new Swiper(swiperEl, {
    loop: true,
    spaceBetween: 10,
    slidesPerView: 1,
    pagination: {
      el: swiperEl.querySelector('.swiper-pagination'),
      clickable: true
    },
    navigation: {
      nextEl: swiperEl.querySelector('.swiper-button-next'),
      prevEl: swiperEl.querySelector('.swiper-button-prev')
    },
    zoom: true
  });
}

// Retry until Swiper is available, then init
function bootstrapProductSwiper() {
  if (typeof Swiper !== 'undefined') {
    initProductSwiper();
    return;
  }
  // Try again on the next animation frame; swiper-bundle.min.js is defered
  requestAnimationFrame(bootstrapProductSwiper);
}

// Watch real DOM changes (only attempt to init if Swiper is loaded)
const observer = new MutationObserver(() => {
  if (typeof Swiper !== 'undefined') initProductSwiper();
});

// Start observing
observer.observe(document.body, {
  childList: true,
  subtree: true
});

// Kick off on DOMContentLoaded; if Swiper isn't loaded yet, poll until it is
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', bootstrapProductSwiper);
} else {
  bootstrapProductSwiper();
}

// Belt and suspenders: also init on full window load
window.addEventListener('load', () => {
  if (typeof Swiper !== 'undefined') initProductSwiper();
});
